import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { shouldDisplayGoogleReviewsSection } from 'urlConfig';
import getGoogleReview from 'utils/GoogleReview/getGoogleReview';
import ReviewerCard from 'components/ReviewerCard';
import generateRandomString from 'utils/stringManipulation';
import { useSchool } from '../../SchoolContext';
import { getGoogleReviewsData } from '../../utils';
import ProfileSection from '../ProfileSection';
import styles from './styles.module.css';

function GoogleReviews({ isFetching }) {
  const { schoolData } = useSchool();
  const { placeId } = getGoogleReviewsData(schoolData || {});
  const [useReviews, setUseReviews] = useState();

  useEffect(() => {
    const loadReviews = async () => {
      if (!placeId) return;
      try {
        const reviews = await getGoogleReview(placeId, 'es');
        if (shouldDisplayGoogleReviewsSection()) {
          setUseReviews(reviews);
        }
      } catch (err) {
        console.error('Error fetching Google reviews:', err);
      }
    };

    loadReviews();
  }, [placeId]);

  if (isFetching) {
    return <>...loading</>;
  }

  if (!useReviews) {
    return <>{' '}</>;
  }

  return (
    <ProfileSection title="Reseñas">
      <div className={styles.reviwesContainer}>
        {useReviews.map((review) => (
          <ReviewerCard
            reviewer={review}
            key={generateRandomString()}
          />
        ))}
      </div>
    </ProfileSection>
  );
}

GoogleReviews.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};

export default GoogleReviews;
